import { AUTH_LOGIN_ERROR, AUTH_LOGIN_REQUEST, AUTH_LOGIN_SUCCESS, AUTH_IDENTIFY_SUCCESS } from '../types';
import { assignCurrentCart } from '../cart';
import { loadUser } from '../user/load-user';
export const loginRequest = email => {
  return {
    type: AUTH_LOGIN_REQUEST,
    payload: {
      email
    }
  };
};
export const loginSuccess = payload => {
  return {
    type: AUTH_LOGIN_SUCCESS,
    payload
  };
};
export const loginError = function (error) {
  let meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    type: AUTH_LOGIN_ERROR,
    error: true,
    meta,
    payload: {
      error
    }
  };
};
const identifySuccess = token => {
  return {
    type: AUTH_IDENTIFY_SUCCESS,
    payload: {
      token
    }
  };
};
export const login = options => {
  return async (dispatch, _getState, _ref) => {
    let {
      auth
    } = _ref;
    const {
      email,
      showUI = false,
      redirectURI = window.location.href
    } = options;
    try {
      dispatch(loginRequest(email));
      await auth.login({
        email,
        showUI,
        redirectURI
      });
      const token = await auth.getToken();
      dispatch(identifySuccess(token));
      const metadata = await auth.getUser();
      dispatch(loginSuccess({
        email: metadata.email,
        token
      }));
      // Fetch the user from the OMS, now that we have logged in
      await dispatch(loadUser());
    } catch (error) {
      dispatch(loginError(error, {
        email,
        showUI,
        redirectURI
      }));
      throw error;
    }
    // If the user has a current cart, associate it with the logged in user
    try {
      await dispatch(assignCurrentCart());
    } catch (error) {
      console.error('Error associating cart with user', error);
    }
  };
};